import { createFileRoute } from '@tanstack/react-router';
import { zodSearchValidator } from '@tanstack/router-zod-adapter';

import { agentsSearchSchema } from '../../types/agentsSearchSchema';
import { AgentsOverviewPage } from '../agent/AgentsOverviewPage';

export const Route = createFileRoute('/_app/agents/')({
    component: AgentsOverviewPage,
    validateSearch: zodSearchValidator(agentsSearchSchema),
});
